import {
  CONSENT_CATEGORY_ANALYTICS,
  CONSENT_CATEGORY_MARKETING,
  ConsentPreferences
} from "./types";

export const CONSENT_STORAGE_KEY = "cookie-consent";

export const CONSENT_CHANGED_EVENT = "wingspan:cookie-consent-changed";

export const CONSENT_GATED_PATHS = [
  "/member/sign-in",
  "/auth/login",
  "/v3/persons/invitation",
  "/member/invitation/onboarding"
] as const;

export const DEFAULT_CONSENT_PREFERENCES: ConsentPreferences = {
  [CONSENT_CATEGORY_MARKETING]: false,
  [CONSENT_CATEGORY_ANALYTICS]: false
};
